<template>
  <div id="app">
    <Header routeValue="0" ref="header"></Header>
    <content class="content" @click="handleDel()">
      <div class="banner_box">
        <div class="title_box">
          <img class="label" src="../assets/icon/label.png">
          <span class="title">DEVELOP AND SELL<br/>CUSTOM PRODUCTS</span>
        </div>
        <div class="explain_box">
          <span class="explain">
            <img style="margin-right: 10px" src="../assets/checked.png">
            Catalog of 900+ products
          </span>
          <span class="explain" style="margin-left: 80px;margin-right: 60px">
            <img style="margin-right: 10px" src="../assets/checked.png">
            Easy order management, transparency in production
          </span>
          <span class="explain">
            <img style="margin-right: 10px" src="../assets/checked.png">
            Worldwide Fulfillment
          </span>
        </div>
        <span class="describe">
          We focus on delivering reliable and trustworthy Print-on-Demand Dropshipping<br/>
          Fulfillment Services with a suite of powerful features that help grow your businesses.
          </span>
        <span class="btn_now" @click="toDesign">
          Start Design for Free<div class="icon" style="margin-left: 10px;">
          <img src="../assets/icon/right_arrow.png"></div>
        </span>
        <span class="latest">
          Latest orders：
          <a-carousel style="width:400px;line-height: 16px;" autoplay :dots="false" :vertical="true">
            <div v-for="item in orderList">
              <div style="display: flex;align-items: center;margin-top: 3px">
                <img src="../assets/icon/location.png"
                     style="width: 10px;height: 14px;margin-right: 5px;margin-top: 2px">
                <span style="font-size: 15px;color: #111111;font-weight: bold;margin-right: 8px;">
                  {{ item.name }}, {{ item.country }}</span>
                <span style="color: #485256">{{ item.time }} minutes ago</span>
              </div>
            </div>
          </a-carousel>
        </span>
        <div class="inside_box">
          <div class="swiper_box">
            <swiper ref="leftSwiper" :options="swiperOption">
              <swiper-slide v-for="(item,index) in dataLefts" :key="'left-'+index">
                <img class="img" :src="item|imgFilter" alt=""/>
              </swiper-slide>
            </swiper>
          </div>
          <div><img src="../assets/icon/+.png" style="margin: 0 33px"></div>
          <div class="swiper_box">
            <swiper ref="centerSwiper" :options="swiperOption">
              <swiper-slide v-for="(item,index) in dataCenters" :key="'center-'+index">
                <img class="img" :src="item|imgFilter" alt=""/>
              </swiper-slide>
            </swiper>
          </div>
          <div><img src="../assets/icon/=.png" style="margin: 0 33px"></div>
          <div class="swiper_box">
            <swiper ref="rightSwiper" :options="swiperOption">
              <swiper-slide v-for="(item,index) in dataRights" :key="'right-'+index">
                <img class="img" :src="item|imgFilter" alt=""/>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div class="poster_banner">
        <a-carousel autoplay>
          <div v-for="(image,i) in bannerList" :key="i">
            <img :src="image|imgFilter()" alt="img" style="width: 100%;height: 450px">
          </div>
        </a-carousel>
      </div>
      <div class="cooperate_box">
        <div class="title_box">
          <img class="label" src="../assets/icon/label.png">
          <span class="title">Cooperate with Partners to Provide<br/>a One-stop Platform</span>
        </div>
        <div class="item_view">
          <div class="item" v-for="item in cooperateList" :key="item.id">
            <div class="image-container">
              <img class="img" :src="item.url|imgFilter" alt=""/>
            </div>
            <div class="title">{{ item.title }}</div>
            <div class="des">{{ item.des }}</div>
          </div>
        </div>
      </div>
      <div class="products_box">
        <div class="title_box">
          <img class="label" src="../assets/icon/label_1.png">
          <span class="title">Globally Best-Selling Products</span>
        </div>
        <span class="des">Choose from 900+ products, simply add your designs</span>
        <div class="tabs_box">
          <a-tabs
            :style="{width: '1280px', textAlign: 'left', marginBottom: '30px'}"
            v-model="activeKey"
            :tabBarStyle="tabBarStyle"
            type="card"
            :tab-position="mode"
            @click.stop="changeTab(activeKey)">

            <a-tab-pane
              class="tab_pane"
              v-for="(item, index) in indexList"
              :key="item.id">
              <template slot="tab">
                <span>
               <svg-icon v-if="item.icon" :icon-class="item.icon"/>
                  {{ item.idxName || item.name}}
                </span>
              </template>
            </a-tab-pane>
          </a-tabs>
          <a-skeleton :loading="isLoading" active :paragraph="{rows: 8, width: 1280}">
            <div class="item_info" v-if="productList.length>0">
              <div class="item_info_r">
                <div class="item" v-for="item in productList.slice(0, 10)" @click="toDetailsDes(item)">
                  <div class="img_box">
                    <img
                      class="img1" :src="item.productImg|imgFilter">
                    <img
                      class="img2" :src="item.productTemplateImg|imgFilter">
                  </div>
                  <span class="name">{{ item.productNameEn }}</span>
                  <span class="price">From <span style="color: #FF5C01;font-size: 18px">
                    USD {{ item.lowestPrice }}
                  </span>
                  </span>
                  <span class="size">{{ item.skuSize }} Size</span>
                </div>
              </div>
            </div>
          </a-skeleton>
        </div>
        <div class="more" v-if="productList.length>0" @click="goToProducts">
          View all
          <img class="img" style="margin-left: 10px;margin-bottom: 3px" src="../assets/icon/right_arrow_1.png">
        </div>
      </div>

      <div class="much_box">
        <div class="title_box">
          <img class="label" src="../assets/icon/label_2.png">
          <span class="title">Check out how much you can earn:</span>
        </div>
        <img class="big_profits" src="../assets/icon/big_profits.png">
        <img class="hot_sales" src="../assets/icon/hot_sales.png">
        <div class="profit_info">
          <!-- 底部绿色覆盖层 -->
          <div class="profit_bottom"></div>
          <div class="profit_content">
            <div class="profit_left">
              <img :src="selectProfit.img|imgFilter" alt="" class="profit_img">
            </div>
            <div class="profit_right">
              <div class="profit_title">
                <span class="title">Select a product</span>
                <span class="price">Fulfillment cost*: ${{ selectProfit.priceCost }}</span>
              </div>

              <div class="tabs_box">
                <a-tabs v-model="activeKey1" :tabBarStyle="tabBarStyle" type="card" @click.stop="changeTab1">
                  <a-tab-pane v-for="item in profitList" :key="item.id" :tab="item.name"/>
                </a-tabs>
              </div>

              <div class="divider"></div>

              <div class="profit_title">
                <span class="title">Quantity and price</span>
              </div>

              <div class="slider-group">
                <div class="slider-title">Sell it for:</div>
                <div class="custom-slider">
                  <a-slider :min="0" :max="100" v-model="selectProfit.price" @change="onChange"
                            :tooltipVisible="false"/>
                  <div class="price">${{ selectProfit.price }}</div>
                </div>
              </div>

              <div class="slider-group">
                <div class="slider-title">Daily orders:</div>
                <div class="custom-slider">
                  <a-slider :min="1" :max="100" v-model="selectProfit.quantity" @change="onChange"
                            :tooltipVisible="false"/>
                  <div class="price">{{ selectProfit.quantity }}</div>
                </div>
              </div>
              <img src="../assets/icon/logo_2.png">
              <div class="profits">
                Your monthly profits:
                <span style="font-weight: 900;font-size: 65px;">${{ selectProfit.profit }}</span>
              </div>
              <div class="start_design" @click="toDesign">
                Start designing
                <div class="icon" style="margin-left: 10px;">
                  <img src="../assets/icon/right_arrow_2.png"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="statistics_box" ref="countToBox">
        <div class="content_global">
          <div class="title_box">
            <img class="label" src="../assets/icon/label_3.png">
            <span class="title">Printbelle offers global shipping:</span>
            <span class="des">Intelligent matching of optimal logistics routes</span>
          </div>
        </div>
        <div class="content_info">
          <div class="item">
            <count-to class="number" suffix="+" :startVal='0' :endVal='900' :duration='3000' ref="countTo1"></count-to>
            <span class="des">Custom products</span>
          </div>
          <div class="item" style="margin-left: 93px">
            <count-to class="number" prefix="$" suffix="+" :startVal='0' :endVal='2000000' :duration='3000'
                      ref="countTo2"></count-to>
            <span class="des">Invested in printing equipment</span>
          </div>
          <div class="item" style="margin-left: 113px">
            <count-to class="number" suffix="+" :startVal='0' :endVal='10000000' :duration='3000'
                      ref="countTo4"></count-to>
            <span class="des">Items fulfilled</span>
          </div>
          <div class="item" style="margin-left: 110px">
            <count-to class="number" suffix="years" :startVal='0' :endVal='10' :duration='3000'
                      ref="countTo3"></count-to>
            <span class="des">Operating time</span>
          </div>
        </div>
      </div>
      <div class="makes_box">
        <div class="makes_type">
          <div class="type_item" v-for="item in makesTypeList" :key="item.id">
            <img class="icon" :src="item.icon" :alt="item.name" :style="{width:item.width,height:item.height}">
            <span class="name">{{ item.name }}</span>
          </div>
        </div>
        <div class="makes_info">
          <span class="title">What makes Printbelle different?</span>
          <div class="makes_view">
            <div class="makes_item" v-for="item in makesList" :key="item.id">
              <img :src="item.icon" :alt="item.name">
              <div class="item_r">
                <span class="name">{{ item.name }}</span>
                <span class="des">{{ item.des }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="customers_box">
        <div class="title_box">
          <img class="label" src="../assets/icon/label_3.png">
          <span class="title">Explore all Success stories</span>
          <span class="des">What our customers are saying</span>
        </div>
        <div class="swiper_box">
          <swiper ref="mySwiper2" :options="option1">
            <swiper-slide v-for="(item,index) in customersList" :key="index">
              <div class="slide_box">
                <div class="top_info">
                  <div class="top_info_l" :style="{background:item.color }">
                    <div class="title">
                      <img style="margin-right: 5px" src="../assets/icon/arrow.png">
                      Success stories
                    </div>
                    <span class="name">{{ item.name }}</span>
                    <span class="subhead">{{ item.subhead }}</span>
                    <a-rate class="level" :default-value="5" disabled>
                      <img slot="character" style="margin-right: -5px" src="../assets/icon/pentacle.png">
                    </a-rate>
                  </div>
                  <img class="head" :src="item.head">
                </div>
                <span class="content" v-html="item.content"></span>
              </div>
            </swiper-slide>
          </swiper>
          <div class="button-prev">
            <img src="../assets/prev.png">
          </div>
          <div class="button-next">
            <img src="../assets/next.png">
          </div>
        </div>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import {get} from '@/api'
import countTo from 'vue-count-to'
import {getRandomInt, shuffle} from '@/utils/utils'

export default {
  name: 'Index',
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide,
    countTo
  },
  data () {
    return {
      mode: 'top',
      nameList: ['Amsterdam', 'ANGOLA', 'Arras', 'Avon', 'Barcelona', 'Bellevign', 'Benitache', 'Brick', 'Brunswick', 'BUDA', 'Budapest', 'Buggenhou', 'Caguas', 'Caloocan', 'Carteret', 'Cavaria C', 'Cedar Par', 'Charleroi', 'Charlesto', 'Charlotte', 'Chesapeak', 'Christchu', 'Clones', 'Communay', 'Crema', 'DEATSVILL', 'Decatur', 'DeRidder', 'Dorfen', 'Durham', 'Elizabeth', 'Fair Oaks', 'Flen', 'Florence', 'Frei', 'French Ca', 'Gambarogn', 'GARY', 'Geel', 'GLENNVILL', 'Hanau', 'Harxheim', 'Hermosill', 'Hoofddorp', 'Jenks', 'Kiel', 'Kilcock', 'KNOXVILLE', 'Kungsback', 'LAKEWOOD', 'Langenloi', 'Lebanon', 'Libertyvi', 'Littlesto', 'Madrid', 'Mainz', 'Malakoff', 'Mangawhai', 'Marion', 'MARYLAND', 'Maryville', 'Mathod', 'Maussane-', 'Merzkirch', 'MILWAUKEE', 'Monthey', 'MOREAUVIL', 'Muhen', 'newnan', 'NORTH LAS', 'Omaha', 'Orange Ci', 'Oslo', 'OTTAWA', 'Palmetto', 'Pandrup', 'Pasig Cit', 'Pelzer', 'POMONA', 'Porto', 'Rheinberg', 'RICHMOND', 'Roseburg', 'ROY', 'Saint Hen', 'Seattle', 'Sevilla', 'Shipshewa', 'shoreline', 'Silver Sp', 'SPRINGDAL', 'Strvring', 'SUMMERVIL', 'Sundsvall', 'THOMSON', 'Timahoe', 'TROY', 'Wilmingto', 'Wittmann', 'wrrstadt'],
      countryList: ['ES', 'SE', 'PH', 'DE', 'NO', 'IT', 'CH', 'NL', 'IE', 'NZ', 'PT', 'FR', 'DK', 'HU', 'AT', 'MX', 'BE'],
      orderList: [{
        name: '',
        country: '',
        time: ''
      }],
      time: null,
      activeKey: 0,
      activeKey1: 0,
      dataLefts: ['/website/inside_l_1.png', '/website/inside_l_2.png', '/website/inside_l_3.png', '/website/inside_l_4.png'],
      dataCenters: ['/website/inside_c_1.png', '/website/inside_c_2.png', '/website/inside_c_3.png', '/website/inside_c_4.png'],
      dataRights: ['/website/inside_r_1.png', '/website/inside_r_2.png', '/website/inside_r_3.png', '/website/inside_r_4.png'],
      bannerList: ['/cdn/poster/poster-08.png', '/website/poster-07.png',],
      cooperateList: [
        {
          url: '/website/design.png',
          title: 'Design',
          des: 'Create your unique products and add them to your store.'
        }, {
          url: '/website/sale.png',
          title: 'Sale',
          des: 'Create your order and pay, we\'ll do the rest.'
        }, {
          url: '/website/product.png',
          title: 'Product',
          des: 'We print, manufacture, and package your orders.'
        }, {
          url: '/website/fulfillment_2.png',
          title: 'Fulfillment',
          des: 'We ship to anywhere in the world. Just wait for the delivery.'
        }
      ],
      dataList: [],
      tabBarStyle: {borderBottom: 'unset'},
      makesList: [
        {
          icon: require('@/assets/icon/makes_1.png'),
          name: 'Diverse Products',
          des: 'Choose from 900+ products, trending categories are continuously \n' +
            'updated, and product quality is guaranteed.\n',
        },
        {
          icon: require('@/assets/icon/makes_2.png'),
          name: 'Fast Production',
          des: 'Intelligent production with fully traceable processes, paired with \n' +
            'flexible, rapid small-batch restocking—empowering quick \n' +
            'adaptation to market demands and accelerated order fulfillment.',
        },
        {
          icon: require('@/assets/icon/makes_3.png'),
          name: 'MOQ=1',
          des: 'Zero inventory risks. Individual customization, wholesale pricing \n' +
            'for single units. Ideal for testing new ideas or serving niche \n' +
            'markets—no need to worry about unsold stock.',
        },
        {
          icon: require('@/assets/icon/makes_4.png'),
          name: 'Competitive Price',
          des: 'The price of our products can be given a discount according to \n' +
            'the quantity; you’ll enjoy huge savings!',
        },
        {
          icon: require('@/assets/icon/makes_5.png'),
          name: 'Free Design Tool',
          des: 'With our free Designer, easily add custom designs to 900+ \n' +
            'high-quality products and publish—fast, simple, free!',
        },
        {
          icon: require('@/assets/icon/makes_6.png'),
          name: 'Stable Logistics',
          des: 'Intelligent matching of optimal logistics routes. Global shipping \n' +
            'reaches 200+ countries, with real-time tracking to keep you in \n' +
            'the loop.',
        },
        {
          icon: require('@/assets/icon/makes_7.png'),
          name: 'A/S Support',
          des: '1-on-1 exclusive service with quick responses and tailored help, \n' +
            'plus 24/7 support delivering solutions crafted for your unique needs.',
        },
        {
          icon: require('@/assets/icon/makes_8.png'),
          name: 'Photography Services',
          des: 'Photography services help you shoot high-quality product videos \n' +
            'in a timely manner, boosting promotions.',
        }
      ],
      makesTypeList: [
        {
          icon: require('@/assets/icon/delivery.png'),
          name: 'Fast Delivery',
          width: '64px',
          height: '54px',
        }, {
          icon: require('@/assets/icon/shipping.png'),
          name: 'Dropshipping',
          width: '78px',
          height: '46px',
        }, {
          icon: require('@/assets/icon/design.png'),
          name: 'Free to Design',
          width: '58px',
          height: '54px',
        }, {
          icon: require('@/assets/icon/guarantee.png'),
          name: 'Returns Guarantee',
          width: '54px',
          height: '58px',
        }
      ],
      customersList: [
        {
          head: require('@/assets/icon/head1.png'),
          name: 'Mortimer',
          color: '#C5FAFF',
          subhead: 'Shopify Merchant',
          content:
            '<span>I have always wanted to start my own business</span>\n' +
            '<span>before, but because l have to distribute the</span>\n' +
            '<span>goods, the cost is relatively high, and l am afraid</span>\n' +
            '<span>that l will not be able to find the market and will</span>\n' +
            '<span>be forced to sell goods. Later l learned about</span>\n' +
            '<span>this platform, with zero inventory, minimum</span>\n' +
            '<span>order of one piece, and personalized design, all</span>\n' +
            '<span>of which met my needs. l am very grateful to</span>\n' +
            '<span>this platform for allowing me to embark on the</span>\n' +
            '<span>path of self-employment.</span>',
        },
        {
          head: require('@/assets/icon/head2.png'),
          name: 'Leilani',
          color: '#F0DDFF',
          subhead: 'Amazon Merchant',
          content:
            '<span>When l first started cross-border e-commerce,</span>\n' +
            '<span>l was quite confused and didn\'t know how to</span>\n' +
            '<span>choose products. l accidentally heard about the</span>\n' +
            '<span>printbelle platform from a friend. The complete</span>\n' +
            '<span>supply chain system completely solved my</span>\n' +
            '<span>problem. As long as l put the product in the</span>\n' +
            '<span>store and ship it, l just have to leave it to print-</span>\n' +
            '<span>belle, which saves worry and effort.</span>',
        },
        {
          head: require('@/assets/icon/head3.png'),
          name: 'Blake',
          color: '#FDF1D0',
          subhead: 'Etsy seller',
          content:
            '<span>You can design your own patterns, which</span>\n' +
            '<span>greatly improves customers\' shopping experi-</span>\n' +
            '<span>ence. The quality of the clothes is also very</span>\n' +
            '<span>good, soft and comfortable. Every piece of</span>\n' +
            '<span>clothing is carefully inspected before shipment</span>\n' +
            '<span>to see that there are no excess threads. The</span>\n' +
            '<span>printing process is also very good, and l</span>\n' +
            '<span>haven\'t received any feedback that the pattern</span>\n' +
            '<span>will fade.</span>',
        }
      ],
      indexList: [],
      productList: [],
      selectProfit: {
        id: 0,
        name: 'T-shirt',
        img: '/website/evaluate_2.jpg',
        priceCost: 0,
        price: 0,
        quantity: 1,
        profit: 0
      },
      profitList: [{
        id: 0,
        name: 'T-shirt',
        img: '/website/evaluate_2.jpg',
        priceCost: 0,
        price: 0,
        quantity: 1,
        profit: 0
      }, {
        id: 1,
        name: '20oz tumbler',
        img: '/website/evaluate_1.jpg',
        priceCost: 0,
        price: 0,
        quantity: 1,
        profit: 0
      }, {
        id: 2,
        name: 'Ornament',
        img: '/website/evaluate_3.jpg',
        priceCost: 0,
        price: 0,
        quantity: 1,
        profit: 0
      }, {
        id: 3,
        name: 'Leather Handbag',
        img: '/website/evaluate_5.jpg',
        priceCost: 0,
        price: 0,
        quantity: 1,
        profit: 0
      }, {
        id: 4,
        name: 'Doormat',
        img: '/website/evaluate_4.jpg',
        priceCost: 0,
        price: 0,
        quantity: 1,
        profit: 0
      }],
      originalProfitList: [],
      options: [],
      isLoading: false,
      pageNum: 1,
      pageSize: 20,
      swiperOption: {
        direction: 'vertical',
        allowTouchMove: false,    // 禁止拖动
        simulateTouch: false,     // 禁止模拟触摸
        noSwiping: true,          // 禁止滑动
        // 保持鼠标和键盘禁用
        mousewheel: {enabled: false},
        keyboard: {enabled: false},
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        on: {
          init: function () {
          },
        }
      },
      option1: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
  computed: {
    swiper () {
      return [
        this.$refs.mySwiper2.swiper,
      ]
    },
  },
  mounted () {
    window.scrollTo({top: 0, behavior: 'smooth'})
    const el = this.$refs.countToBox
    const options = {root: null, rootMargin: '0px', threshold: 0.5}
    const observer = new IntersectionObserver(this.handleIntersection, options)
    observer.observe(el)

    this.nameList.forEach(name => {
      this.orderList.push({name: name, country: this.countryList[getRandomInt(0, this.countryList.length - 1)]})
    })
    shuffle(this.orderList)
    let idx = 1
    this.orderList.forEach(order => {
      order.time = idx
      idx += getRandomInt(0, 2)
    })
  },
  created () {
    this.getIndexCarouselList()
    this.getProductCalcConfig()
    this.getIndexList()
  },
  methods: {
    handleDel () {
      this.$refs.header.delProductValue()
    },
    goToProducts () {
      this.$router.push({path: '/products'})
    },
    callback (val) {
      console.log(val)
    },
    getIndexCarouselList () {
      get('/index/carousel')
        .then(response => {
          this.dataList = response.data
        })
        .catch(error => {
          console.error(error)
        })

    },
    getProductCalcConfig () {
      get('/index/product/calc/config')
        .then(response => {
          this.profitList = this.profitList.map(item => {
            const responseItem = response.data.find((resItem, index) => index === item.id)
            const cost = responseItem ? Number(responseItem.cost) || 0 : 0
            const sale = responseItem ? Number(responseItem.sale) || 0 : 0
            const quantity = 1
            return {
              ...item,
              priceCost: cost,
              price: sale,
              quantity: quantity,
              profit: ((sale - cost) * quantity * 31).toFixed(2)
            }
          })
          this.originalProfitList = JSON.parse(JSON.stringify(this.profitList))
          this.selectProfit = this.profitList[0] || null
        })
        .catch(error => {
          console.error(error)
        })

    },
    getIndexList () {
      this.isLoading = true
      get('/index')
        .then(response => {
          this.indexList = response.data
          if (this.indexList.length > 0) {
            this.indexList.forEach(item => {
              item.productDTOList.forEach(onItem => {
                if (!onItem.productTemplateImg) {
                  onItem['productTemplateImg'] = onItem.productImg
                }
              })
            })
            this.productList = this.indexList[0].productDTOList
            this.activeKey = this.indexList[0].id
          }
          this.isLoading = false
        })
        .catch(error => {
          console.error(error)
          this.isLoading = false
        })

    },
    onChange () {
      const {price, priceCost, quantity} = this.selectProfit
      const salePrice = Number(price) || 0
      const costPrice = Number(priceCost) || 0
      const qty = Number(quantity) || 0
      this.selectProfit.profit = Number(((salePrice - costPrice) * qty * 31).toFixed(2))
    },
    changeTab (value) {
      this.isLoading = true
      let indexObj = this.indexList.find((item) => item.id === value)
      this.productList = indexObj.productDTOList

      this.isLoading = false
    },
    changeTab1 () {
      // 从原始数据中获取初始值，而不是当前可能已修改的值
      const originalItem = this.originalProfitList.find(item => item.id === this.activeKey1)
      if (originalItem) {
        // 深拷贝原始数据，避免引用问题
        this.selectProfit = JSON.parse(JSON.stringify(originalItem))
      }
    },

    toDesign () {
      window.open(process.env.VUE_APP_MERCHANT + 'product/designer', '_blank')
    },
    handleIntersection (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$refs.countTo1.start()
          this.$refs.countTo2.start()
          this.$refs.countTo3.start()
          this.$refs.countTo4.start()
        }
      })
    },
    toDetailsDes (item) {
      window.open(`/products/${item.seoCustomerAddress}`, '_blank')
    },
  },
}
</script>
<style lang="less">

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 36px;
  background: #FFFFFF;
  font-family: HarmonyOS Sans SC;
}

.content .banner_box {
  width: 100%;
  display: flex;
  //margin-top: 72px;
  align-items: center;
  flex-direction: column;
}

.content .banner_box .title_box {
  position: relative;
  margin-top: 75px;
  text-align: center;
  display: inline-block;
}

.content .banner_box .title_box .title {
  position: relative;
  z-index: 2;
  font-weight: 900;
  font-size: 66px;
  line-height: 76px;
  color: #222222;
}

.content .banner_box .title_box .label {
  position: absolute;
  bottom: -10px;
  left: 20px;
  z-index: 1;
}

.content .banner_box .explain_box {
  margin-top: 45px;
  margin-left: 60px;
  display: flex;
}


.content .banner_box .explain_box .explain {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 16px;
  color: #111111;

}

.content .banner_box .describe {
  line-height: 28px;
  font-weight: 400;
  font-size: 20px;
  text-align: center;
  color: #888A96;
  margin-top: 33px;
}


.content .banner_box .btn_now {
  width: 262px;
  height: 53px;
  background: #012169;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  line-height: 30px;
  cursor: pointer;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 18px;
  display: flex;
  margin-bottom: 40px;
  margin-top: 43px;
}

.right-arrow {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-top: 2px solid #F7EAFE;
  border-left: 2px solid #F7EAFE;
  transform: rotate(135deg)
}

.content .banner_box .btn_now .icon {
  animation: slide-right 2s infinite;
}

.content .banner_box .latest {
  display: flex;
  font-weight: 400;
  margin-left: 150px;
  font-size: 15px;
  color: #333333;
}

.content .banner_box .explain .icon {
  color: #343183;
  font-size: 24px;
  margin-right: 10px
}

.content .banner_box .inside_box {
  display: flex;
  align-items: center;
  margin-top: 50px;
}

.content .banner_box .inside_box .swiper_box {
  width: 364px;
  height: 364px;
  position: relative;
}

.content .banner_box .inside_box .swiper_box .swiper-container {
  width: 364px;
  height: 364px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.content .banner_box .inside_box .swiper_box .swiper-container .img {
  width: 364px;
  height: 364px;
}

.content .poster_banner {
  width: 1280px;
  height: 450px;
  background: #E3E3E3;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 75px;

  img {
    display: block;
    border-radius: 20px;
  }
}

.content .cooperate_box {
  width: 1280px;
  display: flex;
  margin-top: 55px;
  align-items: center;
  flex-direction: column;

  .title_box {
    display: flex;
    position: relative;
    text-align: center;

    .title {
      z-index: 2;
      font-weight: 900;
      font-size: 55px;
      color: #222222;
      line-height: 65px;
    }

    .label {
      width: 244px;
      height: 25px;
      position: absolute;
      bottom: -10px;
      left: 42%;
      z-index: 1;
    }
  }

  .item_view {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    margin-top: 50px;

    .item {
      width: 629px;
      margin-bottom: 12px;
      overflow: hidden;

      .image-container {
        width: 629px;
        height: 403px;
        overflow: hidden;
        position: relative;
        border-radius: 10px;
        cursor: pointer;

        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
          transform-origin: center center;
        }

        .img:hover {
          transform: scale(1.05);
        }
      }

      .title {
        font-weight: bold;
        font-size: 30px;
        line-height: 41px;
        margin-top: 8px;
        color: #111111;
      }

      .des {
        font-weight: 400;
        font-size: 18px;
        color: #888A96;
        margin-top: 4px;
      }
    }
  }


}

.content .do_box {
  height: 614px;
  background: #F8FAFC;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content .do_box .do_item {
  width: 730px;
  height: 459px;
  margin-right: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 25px;
}

.content .do_box .do_item .title {
  font-weight: bold;
  font-size: 50px;
  line-height: 50px;
  color: #222222;
  margin-top: 36px;
  margin-bottom: 29px;

}

.content .do_box .do_item .design_box {
  width: 688px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  font-weight: bold;
  font-family: Cerebri Sans;
  font-size: 30px;
  color: #222222;
  z-index: 2;
}

.content .do_box .do_item .design_box span:nth-child(1) {
  width: 312px;
  height: 54px;
  line-height: 54px;
  background: #F8FAFC;
  text-align: center;
  border-radius: 27px;
}

.content .do_box .do_item .design_box span:nth-child(3) {
  width: 312px;
  height: 54px;
  line-height: 54px;
  background: #F8FAFC;
  text-align: center;
  border-radius: 27px;
}

.content .do_box .do_item .img_box {
  width: 100%;
  display: flex;
  justify-content: space-evenly;

}

.content .do_box .do_item .img_box .img_item {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden;
  transition: all ease 0.3s;
}

.content .do_box .do_item .img_box .img_item:hover {
  display: flex;
  flex-direction: column;

}

.content .do_box .do_item .img_box .img_item:hover .img {
  transition: all ease 0.6s;
  transform: scale(1.1);
}

.content .do_box .do_item .img_box .img_item .img {
  width: 225px;
  height: 225px;
  margin-top: -10px;
  margin-bottom: -20px;
  z-index: 1;
}

.content .do_box .do_item .img_box .img_item .des {
  font-family: HarmonyOS Sans SC;
  z-index: 2;
  font-weight: 500;
  font-size: 16px;
  color: #485256;
  text-align: center;
  line-height: 24px;
}

.content .products_box {
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title_box {
    display: flex;
    position: relative;
    text-align: center;
    margin-top: 75px;

    .title {
      z-index: 2;
      font-weight: 900;
      font-size: 55px;
      color: #222222;
    }

    .label {
      position: absolute;
      bottom: 0;
      left: 35%;
      z-index: 1;
    }
  }
}

.content .products_box .more {
  width: 159px;
  height: 46px;
  line-height: 45px;
  background: #FFFFFF;
  border-radius: 7px;
  border: 1px solid #888A96;
  font-weight: 500;
  font-size: 18px;
  color: #FF5C01;
  text-align: center;
  cursor: pointer;
  margin-top: 48px;
  transition: all ease 0.6s;
}

.content .products_box .more:hover {
  border: 1px solid #FF5C01;
}

.content .products_box .more .img {
  animation: slide-right 2s infinite;
}


.content .products_box .des {
  font-weight: 400;
  font-size: 20px;
  color: #888A96;
  margin-top: 8px;
}

.content .products_box .tabs_box {
  width: 1280px;
  display: flex;
  flex-direction: column;
  margin-top: 43px;
  background: #FFFFFF;
}

.content .products_box .tabs_box .item_info {
  display: flex;
}


.content .products_box .tabs_box .item_info .item_info_r {
  width: 100%;
  height: 675px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
}

.content .products_box .tabs_box .item_info .item_info_r .item {
  width: 244px;
  border-radius: 8px;
  display: flex;
  background: #FFFFFF;
  flex-direction: column;
  cursor: pointer;
}


.content .products_box .tabs_box .item_info .item_info_r .item .img_box {
  width: 244px;
  height: 244px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  transition: all ease 0.3s;
}


.content .products_box .tabs_box .item_info .item_info_r .item .img_box .img1 {
  width: 100%;
  height: 100%;
  opacity: 1;
  position: absolute;
  top: 0;
  transition: all ease 0.6s;
}

.content .products_box .tabs_box .item_info .item_info_r .item:hover .img_box .img1 {
  opacity: 0;
  transform: scale(1.05);
}

.content .products_box .tabs_box .item_info .item_info_r .item .img_box .img2 {
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  transition: all ease 0.6s;
}

.content .products_box .tabs_box .item_info .item_info_r .item:hover .img_box .img2 {
  opacity: 1;
  transform: scale(1.05);
}


.content .products_box .tabs_box .item_info .item_info_r .item .name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  margin: 5px 8px 1px 8px;
  font-weight: 500;
  font-size: 16px;
  color: #111111;
}

.content .products_box .tabs_box .item_info .item_info_r .item .price {
  width: 200px;
  font-weight: 500;
  font-size: 16px;
  margin-left: 8px;
  color: #111111;
}

.content .products_box .tabs_box .item_info .item_info_r .item .size {
  width: 200px;
  font-weight: 400;
  font-size: 16px;
  color: #888A96;
  margin: 0 6px;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}

.content .much_box {
  background: #FFFFFF;
  display: flex;
  margin-top: 73px;
  flex-direction: column;
  align-items: center;
  position: relative;

  .big_profits {
    position: absolute;
    left: -32px;
    top: 103px;
    z-index: 30;
    transform-origin: bottom left;
    animation: rotateAndPause 4s ease-in-out infinite 0.1s;
  }

  .hot_sales {
    position: absolute;
    left: -25px;
    top: 70px;
    z-index: 30;
    transform-origin: bottom left;
    animation: rotateAndPause 4s ease-in-out infinite 0.1s;
  }

  @keyframes rotateAndPause {
    0% {
      transform: rotate(0deg);
    }
    10% {
      transform: rotate(-10deg);
    }
    20% {
      transform: translateY(0);
    }
  }

  .title_box {
    position: relative;

    text-align: center;
    display: inline-block;

    .title {
      position: relative;
      z-index: 2;
      font-weight: 900;
      font-size: 55px;
      color: #222222;
    }

    .label {
      position: absolute;
      bottom: 0;
      left: 37%;
      z-index: 1;
    }
  }

  .profit_info {
    position: relative;
    width: 1280px;
    height: 714px;
    background: #D9FDD6;
    margin-top: 33px;
    overflow: hidden;

  }

  .profit_bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 247px;
    background: #0B550F;
    z-index: 1;
  }

  .profit_content {
    position: relative;
    z-index: 2;
    display: flex;
    height: 100%;
    box-sizing: border-box;
  }

  .profit_left {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin: 20px;

    .profit_img {
      width: 591px;
      height: 671px;
      object-fit: cover;
    }

  }

  .profit_right {
    flex: 1;
    padding: 27px 30px 40px 10px;

    // 标题区域
    .profit_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .title {
        font-weight: bold;
        font-size: 22px;
        color: #222222;
        margin: 0;
      }

      .price {
        font-weight: 400;
        font-size: 18px;
        color: #222222;
        margin: 0;
      }

    }

    // 标签页区域
    .tabs_box {

      .ant-tabs.ant-tabs-card .ant-tabs-card-bar {
        .ant-tabs-nav-wrap {
          padding-bottom: 5px;
        }

        .ant-tabs-tab {
          min-width: 78px;
          height: 31px;
          line-height: 28px;
          background: #FFFFFF;
          border-radius: 23px;
          margin-right: 13px;
          border: 1px solid #646464;
          font-weight: 500;
          font-size: 16px;
          text-align: center;
          padding: 0 13px;
          color: #808080;
          transition: all 0.3s ease;

          &:last-child {
            margin-right: 0;
          }

          &:hover {
            border-color: #111111;
            color: #111111;
          }
        }

        .ant-tabs-tab-active {
          color: #FFFFFF !important;
          background: #111111 !important;
          border-color: #111111 !important;
        }
      }
    }

    // 分割线
    .divider {
      width: 100%;
      max-width: 611px;
      margin: 7px 0 20px 0;
      height: 1px;
      background: #0B550F;
    }

    // 滑块标题
    .slider-title {
      font-weight: 400;
      font-size: 18px;
      color: #222222;
      margin-bottom: 3px;

      &:first-of-type {
        margin-top: 28px;
      }
    }

    // 自定义滑块区域
    .custom-slider {
      display: flex;
      align-items: center;
      gap: 22px;
      margin-bottom: 40px;

      .ant-slider {
        flex: 1;
        max-width: 86%;
        margin: 0;

        .ant-slider-rail {
          height: 7px;
          border-radius: 3px;
          border: 1px solid #000000;
          background: #f5f5f5;
        }

        .ant-slider-track {
          height: 6px;
          background: #111111;
          border-radius: 3px;
        }

        .ant-slider-handle {
          width: 20px;
          height: 20px;
          margin-top: -6px;
          background: #111111;
          border: 2px solid #111111;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          transition: box-shadow 0.3s ease;

          &:focus {
            box-shadow: 0 0 0 5px rgba(11, 85, 15, 0.3);
            border-color: #111111;
          }

          &:hover {
            box-shadow: 0 0 0 6px rgba(11, 85, 15, 0.2);
          }
        }
      }

      .price {
        min-width: 79px;
        height: 36px;
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        line-height: 36px;
        text-align: center;
        background: #FFFFFF;
        border-radius: 7px;
        border: 1px solid #646464;
        padding: 0 8px;
      }
    }

    .profits {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 20px;
      gap: 14px;
      margin-top: 22px;
      line-height: 65px;
      color: #FFFFFF;
    }


    .start_design {
      width: 206px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #D9FDD6;
      border-radius: 7px;
      border: 1px solid #888A96;
      font-weight: 500;
      font-size: 20px;
      color: #0B550F;
      cursor: pointer;
      margin-top: 40px;
      transition: all ease 0.6s;
    }


    .start_design .icon {
      animation: slide-right 2s infinite;
    }

  }
}

.content .statistics_box {
  width: 1905px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 85px;
}

.content .statistics_box .content_global {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 786px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url(../assets/icon/global_map.png);

  .title_box {
    display: flex;
    position: relative;
    flex-direction: column;
    text-align: center;
    margin-top: 65px;

    .title {
      z-index: 2;
      font-weight: 900;
      font-size: 55px;
      color: #222222;
    }

    .label {
      position: absolute;
      top: 59px;
      left: 36%;
      z-index: 1;
    }

    .des {
      font-weight: 400;
      font-size: 20px;
      color: #888A96;
      margin-top: 16px;
    }
  }
}

.content .statistics_box .content_info {
  width: 100%;
  display: flex;
  align-items: center;
  height: 150px;
  background: #012169;
  position: relative;
}


.content .statistics_box .content_info .item {
  display: flex;
  flex-direction: column;
  margin-left: 320px;
}

.content .statistics_box .content_info .item .number {
  font-weight: 900;
  font-size: 50px;
  color: #C5FAFF;
  line-height: 50px;
  display: inline-block;
}

.content .statistics_box .content_info .item .des {
  font-weight: 500;
  font-size: 20px;
  color: #C5FAFF;
  line-height: 20px;
  margin-top: 10px;
}


.content .makes_box {
  width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 64px;

  .makes_type {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 20px; /* 添加间距 */
  }

  .type_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 297px;
    height: 143px;
    background: #F4F4F4;
    border-radius: 10px;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .type_item:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
  }

  .type_item .name {
    font-weight: bold;
    font-size: 20px;
    margin-top: 16px;
    color: #111111;
  }

  .type_item .icon {
    width: 50px;
    height: 50px;
    object-fit: contain;
  }

  .makes_info {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 704px;
    margin-top: 40px;
    background: #F0DDFF;
    padding: 50px 0;
    box-sizing: border-box;
  }

  .title {
    font-weight: 900;
    font-size: 36px;
    color: #222222;
    margin-bottom: 43px;
    text-align: center;
  }

  .makes_view {
    width: 100%;
    max-width: 1167px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 35px;
    justify-content: start;
    margin: 0 auto;
  }

  .makes_item {
    display: flex;
    align-items: flex-start;
    min-width: 0;
  }

  .makes_item:nth-child(even) {
    margin-left: 30px;
  }

  .item_r {
    display: flex;
    flex-direction: column;
    margin-left: 17px;
    min-width: 0;
  }

  .item_r .name {
    font-weight: bold;
    font-size: 28px;
    line-height: 28px;
    color: #111111;
    margin-bottom: 12px;
  }

  .item_r .des {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #111111;
    white-space: pre-line;
    word-break: break-word;
  }
}


.content .customers_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 72px;

  .title_box {
    display: flex;
    position: relative;
    flex-direction: column;
    text-align: center;

    .title {
      z-index: 2;
      font-weight: 900;
      font-size: 55px;
      color: #222222;
    }

    .label {
      position: absolute;
      bottom: 36px;
      left: 32%;
      z-index: 1;
    }

    .des {
      font-weight: 400;
      font-size: 20px;
      color: #888A96;
      margin-top: 9px;
    }
  }
}


.content .customers_box .swiper_box {
  width: 1380px;
  height: 530px;
  display: flex;
  position: relative;
}


.content .customers_box .swiper_box .button-prev {
  position: absolute;
  top: 50%;
  opacity: 0;
  left: 5px;
  cursor: pointer;
  transition: all ease 0.8s;
}

.content .customers_box .swiper_box:hover .button-prev {
  opacity: 1;
}

.content .customers_box .swiper_box .button-next {
  position: absolute;
  top: 50%;
  opacity: 0;
  right: 2px;
  cursor: pointer;
  transition: all ease 0.8s;
}

.content .customers_box .swiper_box:hover .button-next {
  opacity: 1;
}

.content .customers_box .swiper_box .swiper-container {
  width: 1300px;
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  transform: translate(-50%, -50%);
}

.content .customers_box .swiper_box .swiper-container .slide_box {
  width: 403px;
  height: 480px;
  background: #FFFFFF;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.15);
  border-radius: 7px;
  margin-left: 13px;
  margin-bottom: 20px;
  margin-top: 50px;
  cursor: pointer;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info {
  display: flex;
  height: 199px;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .top_info_l {
  display: flex;
  flex: 1;
  flex-direction: column;
  border-top-left-radius: 7px;
  background: #C5FAFF;
  padding-left: 19px;
  padding-top: 25px;

  .title {
    font-weight: 400;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #111111;
  }
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .head {
  width: 175px;
  height: 199px;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .name {
  font-weight: bold;
  font-size: 26px;
  color: #111111;
  line-height: 25px;
  margin-left: 17px;
  margin-top: 20px;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .subhead {
  font-weight: bold;
  font-size: 18px;
  color: #111111;
  margin-left: 17px;
  margin-top: 12px;
  line-height: 25px;
}

.content .customers_box .swiper_box .swiper-container .slide_box .top_info .level {
  margin-top: 13px;
  margin-left: 17px;
}

.content .customers_box .swiper_box .swiper-container .slide_box .content {
  display: flex;
  align-items: start;
  font-weight: 400;
  font-size: 16px;
  color: #111111;
  line-height: 23px;
  padding-left: 28px;
  margin-top: 25px;
}

.ant-rate {
  color: #343183;
}

.content {
  .swiper-pagination-bullet {
    background: #FFFFFF;
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab:last-child {
    margin-right: 0;
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    font-family: HarmonyOS Sans SC;
    min-width: 120px;
    line-height: 49px;
    font-weight: 500;
    font-size: 20px;
    padding: 0 24px;
    margin-right: 22px;
    height: 49px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #C2C2C2;
    color: #111111;

    /* 图标默认样式 */

    .anticon {
      transition: color 0.3s ease;
      margin-right: 2px;
    }
  }

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
    height: 49px;
    line-height: 49px;
  }

  .ant-tabs-tab-prev-icon-target, .ant-tabs-tab-next-icon-target {
    font-size: 20px;
    margin-top: 22px;
  }

  .ant-tabs-tab-prev {
    left: -10px;
  }

  .ant-tabs-tab-next {
    right: -10px;
  }


  /* 激活状态 - 只改变图标颜色 */

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    color: #111111; /* 文字颜色保持不变 */
    background: #FFFFFF;
    border: 1px solid #FF5C01;
    text-shadow: none;

    .svg-icon {
      color: #FF5C01; /* 激活状态的图标颜色 */
    }
  }

  /* 鼠标悬停状态 - 只改变图标颜色 */

  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab:hover {
    color: #111111; /* 文字颜色保持不变 */

  }

  /* 确保文字颜色在任何状态下都不变 */

  .ant-tabs-tab {
    span:not(.anticon) {
      color: #111111 !important; /* 强制文字颜色 */
    }
  }
}

@keyframes slide-right {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slide-left {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(5%);
  }
  100% {
    transform: translateY(0);
  }
}


</style>



// WEBPACK FOOTER //
// src/views/Index.vue